import { Delete, Edit, Visibility } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export const getBedRequestsColumns = (
  handleView: (bedRequest: any) => void,
  handleEdit: (bedRequest: any) => void,
  handleDelete: (bedRequest: any) => void
) => [
  {
    field: "_id",
    headerName: "ID",
    width: 100,
    editable: false,
  },
  {
    field: "patientName",
    headerName: "Patient",
    width: 100,
    editable: false,
  },
  {
    field: "hospitalId",
    headerName: "Hospital",
    width: 100,
    editable: false,
    valueGetter: (params: any) => {
      return params?.name || "N/A";
    },
  },
  {
    field: "bedType",
    headerName: "Bed Type",
    width: 100,
    editable: false,
  },
  {
    field: "requestedAt",
    headerName: "Requested At",
    width: 100,
    editable: false,
  },
  {
    field: "urgencyLevel",
    headerName: "Urgency Level",
    width: 100,
    editable: false,
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    editable: false,
  },
  {
    field: "createdAt",
    headerName: "Created At",
    width: 100,
    editable: false,
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 200,
    sortable: false,
    filterable: false,
    renderCell: (params: any) => (
      <>
        <IconButton
          color="primary"
          aria-label="view bed request"
          onClick={() => handleView(params.row)}
        >
          <Visibility />
        </IconButton>
        <IconButton
          color="secondary"
          aria-label="edit bed request"
          onClick={() => handleEdit(params.row)}
        >
          <Edit />
        </IconButton>
        <IconButton
          color="error"
          aria-label="delete bed request"
          onClick={() => handleDelete(params.row)}
        >
          <Delete />
        </IconButton>
      </>
    ),
  },
];
